/* src/app/private/components/student/student-attendance/student-attendance.component.scss */
/*# sourceMappingURL=student-attendance.component.css.map */
